import React, { FC } from "react";
import {
  LookupItemModel,
  LookupTypeEnum,
  SearchPanelPropsModel,
  SuppliersSimpleReportSearchParamsModel,
} from "../../../models";
import { Form } from "react-bootstrap";
import { getLabelName } from "../../../utils";
import { ButtonBox, PrivilegesChecker, SelectBox, TextBox } from "../..";
import { useLookups } from "../../../hooks";

export const ReportSuppliersSimpleSearchPanel: FC<
  SearchPanelPropsModel<SuppliersSimpleReportSearchParamsModel>
> = ({ setLoading, handelSearch, searchParams, setSearchParams, formId }) => {
  //#region state
  const { getLookupItems } = useLookups(setLoading, [
    LookupTypeEnum.Supplier,
    LookupTypeEnum.Cities,
  ]);
  //#endregion
  //#region html
  return (
    <>
      <Form>
        <div 
        className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-1 g-sm-2 g-md-4 align-items-start"
        
        >
          <SelectBox
            labelName={getLabelName("Supplier")}
            isSingleSelect={true}
            selectedValues={
              searchParams.customerId
                ? [searchParams.customerId.toString()]
                : [""]
            }
            source={getLookupItems(LookupTypeEnum.Supplier, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.customerId = undefined;
              } else {
                obj.customerId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />
          <SelectBox
            labelName={getLabelName("City")}
            isSingleSelect={true}
            selectedValues={
              searchParams.cityId ? [searchParams.cityId.toString()] : [""]
            }
            source={getLookupItems(LookupTypeEnum.Cities, true)}
            onStatusChange={(e: LookupItemModel) => {
              const obj = { ...searchParams };
              if (e == null) {
                obj.cityId = undefined;
              } else {
                obj.cityId =
                  e.value === "" || e.value === null
                    ? undefined
                    : parseInt(e.value);
              }
              setSearchParams(obj);
            }}
          />
          <TextBox
            labelName={getLabelName("Account Balance")}
            inputName="CustomerNotPaidSince"
            inputValue={searchParams.CustomerNotPaidSince}
            type="number"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const obj = { ...searchParams };
              if (
                e.target.value === "" ||
                e.target.value === null ||
                e.target.value === undefined
              ) {
                obj.CustomerNotPaidSince = undefined;
              } else {
                obj.CustomerNotPaidSince = parseFloat(e.target.value);
              }
              setSearchParams(obj);
            }}
          />
        </div>
        <PrivilegesChecker formId={formId} action="EnableSearch">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2">
            <ButtonBox
              iconType="magnify"
              className="btn-gradient-primary btn-fw"
              variant="outline-primary"
              onClick={handelSearch}
            >
              {getLabelName("Search")}
            </ButtonBox>
          </div>
        </PrivilegesChecker>
      </Form>
    </>
  );
  //#endregion
};
